import store from 'redux/store'
import * as Actions from 'redux/actions'
import { sendToApi } from 'api/client'
import { WizardTourDismissal } from 'types'

export const WizardTourDismissalService = {
  createWizardTourDismissal: async (wizardTourIdentifier: WizardTourDismissal) => {
    const { auth, workspace } = store.getState()

    store.dispatch(Actions.createWizardTourDismissal(wizardTourIdentifier))

    return sendToApi<{ wizard_tour_dismissal: WizardTourDismissal }>(`/users/${auth?.id}/wizard_tour_dismissals`, {
      method: 'POST',
      body: {
        workspace_id: workspace?.currentWorkspaceId,
        identifier: wizardTourIdentifier,
      },
    })
  },

  deleteWizardTourDismissal: async (wizardTourIdentifier: WizardTourDismissal) => {
    const { auth, workspace } = store.getState()

    return sendToApi<{}>(`/users/${auth?.id}/wizard_tour_dismissals/${wizardTourIdentifier}`, {
      method: 'DELETE',
      body: {
        workspace_id: workspace?.currentWorkspaceId,
      },
    })
  },

  getWizardTourDismissal: async (wizardTourIdentifier: WizardTourDismissal, byWorkspace = true) => {
    const { auth, workspace } = store.getState()

    let url = `/users/${auth?.id}/wizard_tour_dismissals/is_dismissed?identifier=${wizardTourIdentifier}`
    if (byWorkspace) {
      url += `&workspace_id=${workspace?.currentWorkspaceId}`
    }

    return sendToApi<{ is_dismissed: boolean }>(url)
  },

  isDismissed: (wizardTourIdentifier: WizardTourDismissal) => {
    const { wizardTourDismissals } = store.getState()
    return wizardTourDismissals?.includes(wizardTourIdentifier)
  },
}
